module.exports = __webpack_public_path__ + "files/b5ef4c773e2f1c83ff0029bc23edb8d8.png";